import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input, TemplateRef } from '@angular/core';
import { UserDataModel } from '@modules/auth';

@Component({
  selector: 'app-user-avatar',
  templateUrl: './user-avatar.component.html',
  styleUrls: ['./user-avatar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserAvatarComponent {
  @Input() user?: UserDataModel;
  @Input() size = 40;
  @Input() icon?: string;

  @HostBinding('attr.style')
  public get hostSize(): string {
    return `height: ${this.size}px; width: ${this.size}px;`
  }

  public customAvatarStyle = {
    borderRadius: "50%",
    objectFit: "cover",
  };
}
